module.exports = __webpack_public_path__ + "img/speedship-logo.acd42948.png";